import type { SVGProps } from "react";

export type IconName =
  | "chat"
  | "contacts"
  | "plus"
  | "search"
  | "image"
  | "mic"
  | "more"
  | "send"
  | "users"
  | "settings"
  | "logout"
  | "back"
  | "close";

const paths: Record<IconName, string> = {
  chat: "M4 5.5A2.5 2.5 0 0 1 6.5 3h11A2.5 2.5 0 0 1 20 5.5v7a2.5 2.5 0 0 1-2.5 2.5H10l-5 4v-4.45A2.5 2.5 0 0 1 4 12.5z",
  contacts: "M16 20v-1.5A3.5 3.5 0 0 0 12.5 15h-5A3.5 3.5 0 0 0 4 18.5V20M10 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8m7-3v6m3-3h-6",
  plus: "M12 5v14M5 12h14",
  search: "m20 20-4.2-4.2m2.2-5.3a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0",
  image: "M4 5h16v14H4zm0 10 4.5-4.5 3.5 3.5 2.5-2.5L20 17M15.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
  mic: "M12 3a3 3 0 0 0-3 3v5a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3m-7 8a7 7 0 0 0 14 0m-7 7v3m-4 0h8",
  more: "M6 12h.01M12 12h.01M18 12h.01",
  send: "m3 11 18-8-8 18-2-7zM11 14 21 3",
  users: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2m7-10a4 4 0 1 0 0-8 4 4 0 0 0 0 8m13 10v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75",
  settings: "M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m7.4-3.5a7.6 7.6 0 0 0-.08-1l2-1.55-2-3.46-2.48 1a8 8 0 0 0-1.75-1L14.7 3h-4l-.4 2.99a8 8 0 0 0-1.75 1L6.08 6 4 9.45 6 11a7.6 7.6 0 0 0 0 2l-2 1.55L6.08 18l2.47-1a8 8 0 0 0 1.75 1l.4 3h4l.4-3a8 8 0 0 0 1.74-1l2.48 1 2-3.45-2-1.55a7.6 7.6 0 0 0 .08-1",
  logout: "M10 17l5-5-5-5m5 5H3m10-9h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-6",
  back: "m15 18-6-6 6-6",
  close: "M6 6l12 12M18 6 6 18",
};

export function Icon({ name, ...props }: { readonly name: IconName } & SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
      <path d={paths[name]} />
    </svg>
  );
}
